import { findNodeByClass } from './util';
import { isFunction } from '../../../../common/base';
/* QQ互联登录框*/

var qqConnectFrame = {
  isReady: false,
  currentOpt: {},
  $frame: null,
  // 初始化事件等
  init: function init(callback) {
    var self = this;

    if (self.isReady) {
      isFunction(callback) && callback();
      return;
    } // tpl


    var tpl = '<div class="qConnectLoginCover"></div>\
			<div class="qConnectLoginContent">\
				<div>\
					<a class="qConnectClose" href="javascript:void(0)">×</a>\
				</div>\
				<iframe class="loginframe" frameborder="0" src=""></iframe>\
			</div>';
    self.$frame = document.createElement('div');
    self.$frame.classList.add('milo-qConnectLogin');
    self.$frame.innerHTML = tpl;
    document.getElementsByTagName('body')[0].appendChild(self.$frame);
    var closeBtn = findNodeByClass(self.$frame, 'qConnectClose'); // 绑定事件

    closeBtn.addEventListener('click', function () {
      self.close();
    }, false);
    self.isReady = true;
    isFunction(callback) && callback(); // })
  },
  close: function close(isForce) {
    if (this.currentOpt.showParams.canClose || isForce) {
      this.$frame.style.display = 'none';
    }
  },
  show: function show(url, opt) {
    var self = this;
    self.currentOpt = opt;
    this.init(function () {
      var loginframe = findNodeByClass(self.$frame, 'loginframe');
      var cover = findNodeByClass(self.$frame, 'qConnectLoginCover');
      var content = findNodeByClass(self.$frame, 'qConnectLoginContent');
      var closeBtn = findNodeByClass(self.$frame, 'qConnectClose');
      loginframe.setAttribute('src', url);
      /* showParams相关*/
      // zIndex

      var zIndex = Number(opt.showParams.zIndex) || 999;
      self.$frame.style.zIndex = zIndex;
      cover.style.zIndex = zIndex;
      content.style.zIndex = zIndex + 1; // 是否显示cover

      if (opt.showParams.needMask) {
        cover.style.display = 'block';
      } else {
        cover.style.display = 'none';
      } // 是否允许关闭[显示关闭按钮]


      if (!opt.showParams.canClose) {
        closeBtn.style.display = 'none';
      } else {
        closeBtn.style.display = 'block';
      }

      self.$frame.style.display = 'block';
    });
  }
};
export default qqConnectFrame;